export default [
  235, //"fireboat"
  287, //"streetcar"
  237, //"speedboat"
  982, //"scuba diver"
  507, //"snorkel"
  41, //"dalmation"
  176, //"Labrador retriever"
  3, //"Siberian husky"
  2, //"English setter"
  112, //"Doberman"
  158, //"Tibetan terrier"
  14, //"sea lion"
  442, //"great white shark"
  450, //"goldfish"
  454, //"lionfish"
  513, //"oil filter"
  523, //"digital clock"
  529, //"digital watch"
  930, //"comic book"
  600, //"spider web"
  605, //"barn spider"
  736, //"head cabbage"
  744, //"artichoke"
  358, //"yellow lady's slipper"
  756, //"croquet ball"
  936, //"volleyball"
  942, //"parachute"
  943, //"sleeping bag"
  366, //"lakeside"
  365, //"coral reef"
  367, //"seashore"
  484, //"vine snake"
  483, //"water snake"
  488, //"indian cobra"
  489, //"green mamba"
  387, //"goldfinch"
  388, //"house finch"
  399, //"vulture"
  411, //"lorikeet"
  405, //"peacock"
]

// To add
// 547, //abacus
// 671, //frying pan
// 672, //wok
// 6, //grey whale